import { getData } from 'conversations-async-data/async-data/operators/getters';
import { getCurrentReplyRecommendationObject, getLastConversationalMessage, getReplyRecommendationsHistory } from 'conversations-message-history/reply-recommendations/operators/getters';
// @ts-expect-error module not typed
import { useThreadHistory } from 'conversations-thread-view/thread-histories/hooks/useThreadHistory';
// @ts-expect-error module not typed
import { getId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { COMPOSITION_THREAD_ID } from 'conversations-thread-data/communicator/constants/compositionThreadId';
// @ts-expect-error module not typed
import { isFromAgent } from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
// @ts-expect-error module not typed
import { getCurrentThreadHistory } from 'conversations-thread-data/thread-histories/public/selectors/getCurrentThreadHistory';
import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { useSelector } from 'react-redux';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import { SuccessfulReplyRecommendationResponseTypename, UnsuccessfulReplyRecommendationResponseTypename } from '../../../../__generated__/chirp/com/hubspot/cv/replies/rpc/ReplyRecommendationsFrontendService';
import { useGetReplyRecommendationsWithReasonQuery } from '../../../../__generated__/chirp/com/hubspot/cv/replies/rpc/ReplyRecommendationsFrontendService.hooks';
const selectLastConversationalMessage = state => {
  return getLastConversationalMessage(getCurrentThreadHistory(state));
};
const useCurrentReplyRecommendationChirp = ({
  threadId,
  skip
}) => {
  var _user$scopes, _replyRecommendations;
  const {
    user
  } = userInfoSync() || {};
  const isInvalidThreadId = threadId === COMPOSITION_THREAD_ID || isNaN(+threadId);
  const finalThreadId = isInvalidThreadId ? '0' : threadId;
  const hasReplyRecommendationsScope = user === null || user === void 0 || (_user$scopes = user.scopes) === null || _user$scopes === void 0 ? void 0 : _user$scopes.includes('help-desk-reply-recommendations');
  const skipReplyRecs = isInvalidThreadId || !hasReplyRecommendationsScope || skip;
  const {
    data: replyRecommendationsWithReason
  } = useGetReplyRecommendationsWithReasonQuery({
    variables: {
      threadId: +finalThreadId
    },
    skip: skipReplyRecs
  });
  const lastConversationalMessage = useSelector(selectLastConversationalMessage);
  const lastConversationalMessageId = getId(lastConversationalMessage);
  const isAgentOrOutgoingMessage = isFromAgent(lastConversationalMessage) || (lastConversationalMessage === null || lastConversationalMessage === void 0 ? void 0 : lastConversationalMessage.direction) === 'OUTGOING';
  const currentReplyRecommendation = replyRecommendationsWithReason === null || replyRecommendationsWithReason === void 0 || (_replyRecommendations = replyRecommendationsWithReason.replyRecommendations) === null || _replyRecommendations === void 0 ? void 0 : _replyRecommendations.find(replyRecommendation => replyRecommendation.inResponseToMessageId === lastConversationalMessageId);
  const successfulReplyRecommendation = (currentReplyRecommendation === null || currentReplyRecommendation === void 0 ? void 0 : currentReplyRecommendation.__typename) === SuccessfulReplyRecommendationResponseTypename ? currentReplyRecommendation : undefined;
  const unsuccessfulReason = isAgentOrOutgoingMessage ? 'AGENT_OR_OUTGOING_MESSAGE' : (currentReplyRecommendation === null || currentReplyRecommendation === void 0 ? void 0 : currentReplyRecommendation.__typename) === UnsuccessfulReplyRecommendationResponseTypename ? readUnhandledEnumCase(currentReplyRecommendation === null || currentReplyRecommendation === void 0 ? void 0 : currentReplyRecommendation.errorReason) : undefined;
  return {
    currentReplyRecommendation: successfulReplyRecommendation,
    currentReplyRecInResponseTo: (successfulReplyRecommendation === null || successfulReplyRecommendation === void 0 ? void 0 : successfulReplyRecommendation.inResponseToMessageId) || '',
    unsuccessfulReason
  };
};
export const useCurrentReplyRecommendation = ({
  threadId
}) => {
  const isInvalidThreadId = threadId === COMPOSITION_THREAD_ID || isNaN(+threadId);
  const finalThreadId = isInvalidThreadId ? '0' : threadId;
  const {
    gates
  } = userInfoSync() || {};
  const isUngatedForChirpReplyRecommendations = gates === null || gates === void 0 ? void 0 : gates.includes(gate('CustomerAgentGrowth:ChirpReplyRecommendations'));
  const {
    asyncThreadHistory
  } = useThreadHistory({
    threadId: finalThreadId,
    deferred: isInvalidThreadId || isUngatedForChirpReplyRecommendations
  });
  const threadHistory = getData(asyncThreadHistory);
  const chirpResult = useCurrentReplyRecommendationChirp({
    threadId: finalThreadId,
    skip: isInvalidThreadId || !isUngatedForChirpReplyRecommendations
  });
  if (isUngatedForChirpReplyRecommendations) {
    return chirpResult;
  }
  if (!threadHistory) return {
    currentReplyRecInResponseTo: ''
  };
  const replyRecommendationsHistory = getReplyRecommendationsHistory(threadHistory);
  const lastConversationalMessage = getLastConversationalMessage(threadHistory);
  const lastConversationalMessageId = getId(lastConversationalMessage);
  const isAgentOrOutgoingMessage = isFromAgent(lastConversationalMessage) || (lastConversationalMessage === null || lastConversationalMessage === void 0 ? void 0 : lastConversationalMessage.direction) === 'OUTGOING';
  const currentReplyRecommendation = getCurrentReplyRecommendationObject({
    replyRecommendationsHistory,
    lastConversationalMessage
  });
  const successfulReplyRecommendation = (currentReplyRecommendation === null || currentReplyRecommendation === void 0 ? void 0 : currentReplyRecommendation.replyType) === 'SUCCESSFUL' ? currentReplyRecommendation : undefined;
  const unsuccessfulReason = isAgentOrOutgoingMessage ? 'AGENT_OR_OUTGOING_MESSAGE' : successfulReplyRecommendation ? undefined : currentReplyRecommendation === null || currentReplyRecommendation === void 0 ? void 0 : currentReplyRecommendation.errorReason;
  return {
    unsuccessfulReason,
    currentReplyRecommendation: successfulReplyRecommendation,
    currentReplyRecInResponseTo: replyRecommendationsHistory[lastConversationalMessageId] ? lastConversationalMessageId : ''
  };
};